import { useEffect, useState } from "react";

export default function VisitorCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch("https://alg37u7tc4.execute-api.us-east-1.amazonaws.com/count");
        const data = await res.json();
        if (typeof data.count === "number") {
          setCount(data.count);
        }
      } catch (error) {
        console.error("Error fetching visitor count:", error);
      }
    })();
  }, []);

  return (
    <span className="text-sm text-blue-200">
      {count === null ? "Loading visitors..." : `Visitors: ${count.toLocaleString()}`}
    </span>
  );
}
